export default "__VITE_ASSET__CqZFeVPG__"